import { useState, useContext, createContext } from "react";
import { Typography } from "@material-ui/core";
import { IconButton, Button, Tooltip } from "@mui/material";
import { useParams, useHistory } from "react-router-dom";
import { getCachedData } from "api/Cache";
import AddObjectsPanel from "./AddObjectsPanel";
import LayersContent from "./LayersContent";
import SettingsPanel from "./SettingsPanel";
import ViewerEvents from "events/ViewerEvents";
import { ChevronLeft, AddBox, Settings, Layers } from "@mui/icons-material";
import commonStyles, { panelHeaderHeight } from "styles/common";
import leftStyles from "styles/leftPanel";
import { Divider } from "@mui/material";
import { useEffect } from "react";
import {  useDispatch, useSelector } from 'react-redux';
import { useJumboTheme } from 'themes/jumbo/@jumbo/components/JumboTheme/hooks';
import useSwalWrapper from 'themes/jumbo/@jumbo/vendors/sweetalert2/hooks';
import { setData } from "store/main/viewerHistory";

export const ViewContext = createContext({});


const HeaderTitle = (props: {
    view: any;
    newView: boolean;
    update: boolean;
    expand: boolean;
    togglePanel: (evt: any) => void;
    mode: number;
    setMode: (mode: number) => void;
}) => {
    var { classes, cx } = leftStyles();
    const { classes: common } = commonStyles();
    var history = useHistory();
    var { newScene } = ViewerEvents;
    const { theme } = useJumboTheme();

    //console.log("newScene:", newScene);
    const { view, togglePanel, expand, newView, mode, setMode} = props;
    return (
        <div className={`${classes.header} ${theme.type}-theme`}>
            <div className={common.middle} style={{ position: "relative", height: panelHeaderHeight }}>
                <div
                    onClick={() => {
                        if (history.location.state && history.location.state.from) {
                            history.push(history.location.state.from);
                            history.goForward();
                        } else {
                            history.goBack();
                        }
                        //ViewerEvents.emit("destroyView", {});
                    }}
                >
                    <IconButton style={{ width: 40, height: 40 }}>
                        <ChevronLeft sx={{ color: '#fff'}}/>
                    </IconButton>
                </div>
                <Typography
                    className={cx(classes.title, !newScene && !newView ? common.disableEventsNoShades : "")}
                    noWrap
                    onClick={togglePanel}
                >
                    {view.name}
                </Typography>
            </div>
            <div id="toolbar" onClick={togglePanel} className={cx(common.middle, classes.right)}>
                <Tooltip title="Layers Panel" placement="top" arrow>
                <Button
                    onClick={(e) => {
                        setMode(0);
                    }}
                    title="Layers Panel"
                    className={cx(common.button, common.spacingRight)}
                >
                    <Layers className={mode === 0 && expand ? common.selected : common.white} />
                </Button>
                </Tooltip>
                <Tooltip title="Settings" placement="top" arrow>
                <Button
                    onClick={(e) => {
                        setMode(1);
                    }}
                    title="Settings"
                    className={cx(common.button, common.spacingRight)}
                >
                    <Settings className={mode === 1 && expand ? common.selected : common.white} />
                </Button>
                </Tooltip>
                <Divider orientation="vertical" flexItem />
            </div>
        </div>
    );
};

const Toolbar = (props: { view: any; currentProject: any; newScene: boolean }) => {
    const { classes } = leftStyles();
    const { view, currentProject } = props;
    var [open, setOpen] = useState(false);
    const { 
        hasActiveSubscription,
        hasProjectAccess,
        sweetAlerts
    } = useContext<any>(ViewContext);
    const addObjects = (evt: any) => {
        if (!hasActiveSubscription) {
            sweetAlerts();
            return;
        }
        setOpen(true);
    };
    const handleClose = () => {
        setOpen(false);
    };
    return (
        <div>
            <div className={classes.addObject}>
                <div style={{ display: "table-cell", verticalAlign: "middle" }}>
                    <Button color="primary" onClick={addObjects} disabled={!hasProjectAccess}>
                        <AddBox />
                        <span style={{ paddingLeft: 10, fontWeight: "bold" }}>Add Objects</span>
                    </Button>
                </div>
            </div>
            {open ? (
                <AddObjectsPanel open={open} view={view} currentProject={currentProject} handleClose={handleClose} />
            ) : (
                ""
            )}
        </div>
    );
};

const Content = (props: {
    view: any;
    currentProject: any;
    newScene: boolean;
    mode: number;
    updateParent: () => void;
    expand : boolean;
}) => {
    const [move, setMove] = useState(false);
    var { mode } = props;
    //console.log("props:", props);
    const addObjects = (evt: any) => {};
    return (
        <div>
            {mode === 0 ? (
                <div>
                    <Toolbar {...props} />
                    <LayersContent addObjects={addObjects} move={move} setMove={setMove} {...props} />
                </div>
            ) : (
                <SettingsPanel {...props} />
            )}
        </div>
    );
};

export default function LeftPanel() {
    const { classes } = leftStyles();
    const { viewId } = useParams();
    const cachedData = getCachedData();
    const view = cachedData.views[viewId];
    var currentProject = cachedData.entities[view.project];
    var { newScene, layers, inputs, view:_view } = ViewerEvents;
    //console.log("layers:", layers, "|inputs:", inputs, "|newScene:", newScene, ViewerEvents.view);
    var pending = cachedData.pending;
    const newView: any = Boolean(
        Object.values(pending).find((object: any) => object.action === "add" && object.ID === viewId)
    );

    const [update, setUpdate] = useState(false);
    const [expand, setExpand] = useState(false);
    const [mode, setMode] = useState(0);
    
	const storeAuthData = useSelector((state: any) => state.auth);
    const [hasFullAccess, setHasFullAccess] = useState(false);
    const [hasProjectAccess, setHasProjectAccess] = useState(false);
    const { hasActiveSubscription = false, projectAccessLevel:access_level = "read", activeProject, isDefaultProject = false, defaultProjects } = storeAuthData;
     const history = useHistory();
    const Swal = useSwalWrapper();
    const sweetAlerts = () => {
        Swal.fire({
        title: !hasActiveSubscription ? 'Your account has limited access!' : 'You have limited access!',
        text: !hasActiveSubscription ? 'We have limited your access to some features. Please upgrade your current plan to access this feature.' : 'Only users who are included in the permissions for this project can access to this feature.',
        imageWidth: 450,
        imageHeight: 200,
        imageAlt: 'Custom image',
        confirmButtonText: "Upgrade my plan",
        showCloseButton: true,
        }).then((result) => {
            result.isConfirmed && history.push("/profile");
        });
    };
    const dispatch = useDispatch();
    
    const ViewContextValue = {
        hasFullAccess,
        hasProjectAccess,
        hasActiveSubscription, 
        access_level, 
        activeProject, 
        isDefaultProject, 
        defaultProjects,
        sweetAlerts
    } 
    useEffect(() => {
        setHasProjectAccess(access_level === (!!activeProject ? 'full' : 'read'))
        setHasFullAccess(hasActiveSubscription && access_level === (!!activeProject ? 'full' : 'read'))
    }, [activeProject, access_level, hasActiveSubscription])

    useEffect(() => {
        const getLayers = (object: any) => {
            console.log("leftPanel.metadataChanged", object);
            let data = {};
            if (object.inputs && object.inputs !== null) {
                data = {
                    inputs: ViewerEvents.inputs
                }

                ViewerEvents.inputs = object.inputs;
            }
            if (object.layers && object.layers !== null) {
                data = {
                    ...data,
                    layers: ViewerEvents.layers
                }
                ViewerEvents.layers = object.layers;
                setUpdate((prevUpdate) => !prevUpdate);
            }
            Object.keys(data).length && dispatch(setData(JSON.parse(JSON.stringify(data))));
        };
        if (layers.length === 0 && Object.values(inputs).length > 0) {
            ViewerEvents.createLayers();
            setUpdate((prevUpdate) => !prevUpdate);
        }

        ViewerEvents.on("metadataChanged", getLayers);
        ViewerEvents.on("layersReady", getLayers);
        if (newView) {
            setExpand(true);
        }

        

        return () => {
            ViewerEvents.removeEventListener("metadataChanged", getLayers);
            ViewerEvents.removeEventListener("layersReady", getLayers);
        };
    }, [mode, newView, layers, inputs, _view]);

    const togglePanel = (evt: any) => {
        if (evt.target.tagName !== "svg" && evt.target.tagName !== "path" && evt.target.id !== "toolbar") {
            setExpand(!expand);
        } else {
            setExpand(true);
        }
    };

    const updateParent = () => {
        setUpdate((prevUpdate) => !prevUpdate);
    };

    return (
        <ViewContext.Provider value={ViewContextValue}>
            <div className={classes.leftRoot}>
                <HeaderTitle
                    view={view}
                    togglePanel={togglePanel}
                    newView={newView}
                    mode={mode}
                    setMode={setMode}
                    update={update}
                    expand={expand}
                />
                <div className={classes.content} style={{ display: expand ? "flex" : "none" }}>
                    <Content
                        view={view}
                        currentProject={currentProject}
                        newScene={newScene}
                        mode={mode}
                        updateParent={updateParent}
                        expand={expand}
                    />
                </div>
            </div>
        </ViewContext.Provider>
    );
}
